module.exports = __webpack_public_path__ + "img/pending.6e513d16.svg";